import React, { FC, SyntheticEvent } from 'react'

import { ThenPlace } from 'components/block/Then/Then.constants'
import { thenPartPath } from 'components/block/Then/Then.paths'
import { Favourite } from 'components/page/ForeignProfile/InteractiveButtons/Buttons/Favourite'
import { Message } from 'components/page/ForeignProfile/InteractiveButtons/Buttons/Message'
import { Wink } from 'components/page/ForeignProfile/InteractiveButtons/Buttons/Wink'
import {
  ProfileButton,
  ProfileLink,
  ProfilePanel,
} from 'components/page/ForeignProfile/InteractiveButtons/InteractiveButtons.styled'
import { redirectAfterAuthPath } from 'components/paths'
import { removeLocale } from 'components/system/system.functions'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const ProfileActionPanel: FC<{
  isWinked: boolean
  isFavourite: boolean | undefined
  authorized: boolean
  chatPath: string
  authorizationPath: string
  onChatOpen: (event: SyntheticEvent) => void
  onWink: () => void
  onFavourite: () => void
  place: string
}> = ({
  isWinked,
  isFavourite,
  authorized,
  chatPath,
  authorizationPath,
  onChatOpen,
  onWink,
  onFavourite,
  place,
}) => {
  const { baseUrl } = useShallowEqualSelector(
    ({ systemReducer: { baseUrl } }) => ({
      baseUrl,
    })
  )

  if (!authorized) {
    const partPath = mergeAllUrls(
      authorizationPath,
      redirectAfterAuthPath,
      removeLocale(baseUrl),
      thenPartPath
    )

    return (
      <ProfilePanel data-name={`${place}-buttons-parent`}>
        <ProfileLink
          to={mergeAllUrls(partPath, ThenPlace.wink)}
          rel="nofollow"
          data-name="wink-action"
        >
          <Wink isWinked={isWinked} />
        </ProfileLink>
        <ProfileLink
          to={mergeAllUrls(partPath, ThenPlace.messenger)}
          rel="nofollow"
          data-name="chat-action"
        >
          <Message />
        </ProfileLink>
        <ProfileLink
          to={mergeAllUrls(partPath, ThenPlace.favourite)}
          rel="nofollow"
          data-name="favourite-action"
        >
          <Favourite isFavourite={isFavourite} />
        </ProfileLink>
      </ProfilePanel>
    )
  }

  return (
    <ProfilePanel data-name={`${place}-buttons-parent`}>
      <ProfileButton onClick={onWink} data-name="wink-action">
        <Wink isWinked={isWinked} />
      </ProfileButton>
      <ProfileLink to={chatPath} onClick={onChatOpen} data-name="chat-action">
        <Message />
      </ProfileLink>
      <ProfileButton onClick={onFavourite} data-name="favourite-action">
        <Favourite isFavourite={isFavourite} />
      </ProfileButton>
    </ProfilePanel>
  )
}
